import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useHomeContext from 'Context/HomeContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { PrimaryActionButton } from '@facet-wealth/design';

const styles = theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(3)}px`,
    marginBottom: theme.spacing(2),
  },
});

const FacetPlanScenarioActivationConfirmation = ({ classes }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { setPageContentCollection } = usePageContentContext();
  const { clearModalCollection } = useModalContext();
  const { resource } = useMetaLayoutContext();
  const { refreshHomeResource } = useHomeContext();

  const handleSubmit = async () => {
    logStandardizedEvent(categories.clientWhatIf, eventTypes.clickButton, 'Scenario Activation Confirmation - Scenario select button clicked', {
      eventProperties: {
        scenarioId: resource.id(),
      },
    });

    const params = { tz: moment.tz.guess() };

    setIsSubmitting(true);

    try {
      const collection = await resource.link('self').post({}, { params });
      clearModalCollection();
      setPageContentCollection(collection);
      refreshHomeResource();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }

    setIsSubmitting(false);
  };

  return (
    <Box className={classes.root}>
      <Text color={'black'} text={resource.attr('title')} variant="h2" weight="medium" />
      <Text color="mediumGray" text={resource.attr('message')} />
      <PrimaryActionButton
        loading={isSubmitting}
        onClick={async () => {
          await handleSubmit();
        }}
        label={resource.attr('action')}
      />
    </Box>
  );
};

FacetPlanScenarioActivationConfirmation.defaultProps = {};

FacetPlanScenarioActivationConfirmation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanScenarioActivationConfirmation);
